var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGroupLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M34,14.5A3.5,3.5,0,1,1,37.5,18,3.5,3.5,0,0,1,34,14.5Zm.1285,11.1821L34.7928,30H45l-1.8015-9.0073A1.2348,1.2348,0,0,0,41.9877,20H39.5a2,2,0,0,1-4,0H33.0123a1.2348,1.2348,0,0,0-1.2108.9927l-.4085,2.0422A3.1358,3.1358,0,0,1,34.1285,25.6821ZM10.5,18A3.5,3.5,0,1,0,7,14.5,3.5,3.5,0,0,0,10.5,18Zm6.161,5.3049-.4625-2.3122A1.2348,1.2348,0,0,0,14.9877,20H12.5a2,2,0,0,1-4,0H6.0123a1.2348,1.2348,0,0,0-1.2108.9927L3,30H14.2072l.6643-4.3179A3.1358,3.1358,0,0,1,16.661,23.3049ZM24.5,22A4.5,4.5,0,1,0,20,17.5,4.5,4.5,0,0,0,24.5,22Zm7.6517,3.9863A1.1631,1.1631,0,0,0,31.002,25H27.5a3,3,0,0,1-6,0H17.998a1.1631,1.1631,0,0,0-1.15.9863L15,38H34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupLight);
export default __webpack_public_path__ + "static/media/userGroupLight.0463893e3d29f497e744ab7e5bdae48a.svg";
export { ForwardRef as ReactComponent };